export const register = "/web/v1/novel/login";
export const login = "/web/v1/novel/login";
export const email_captcha = "/web/v1/novel/email_captcha";
export const reset_password = "/web/v1/novel/reset_password";
export const refresh = "/web/v1/auth/refresh";
